import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
import VueCropper from 'vue-cropper'; 


Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.config.productionTip = false

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


